import { Link } from 'react-router-dom';
import styled from 'styled-components';

function ListItem({ to, primary, secondary, meta }) {
  const content = (
    <>
      <Body>
        <Primary>{primary}</Primary>
        {secondary && <Secondary>{secondary}</Secondary>}
      </Body>
      {meta && <Meta>{meta}</Meta>}
      {to && <Arrow>→</Arrow>}
    </>
  );

  if (to) {
    return <Row to={to}>{content}</Row>;
  }
  return <StaticRow>{content}</StaticRow>;
}

const sharedRowStyles = `
  width: 100%;
  box-sizing: border-box;
  background: var(--color-navy);
  color: var(--color-paper);
  padding: 18px 28px;
  display: grid;
  grid-template-columns: 1fr auto auto;
  gap: 24px;
  align-items: center;
  text-decoration: none;
  border-bottom: 1px solid rgba(201, 184, 151, 0.06);

  &:last-child {
    border-bottom: none;
  }

  @media (max-width: 575px) {
    padding: 14px 18px;
    grid-template-columns: 1fr auto;
  }
`;

const Row = styled(Link)`
  ${sharedRowStyles}
  cursor: pointer;
  transition: background 0.2s, padding-left 0.2s;

  &:hover {
    background: var(--color-navy-soft);
    padding-left: 36px;
  }

  @media (max-width: 575px) {
    &:hover {
      padding-left: 22px;
    }
  }
`;

const StaticRow = styled.div`
  ${sharedRowStyles}
`;

const Body = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
`;

const Primary = styled.div`
  font-family: var(--font-serif);
  font-weight: 500;
  font-size: 16px;
  color: var(--color-paper);
  letter-spacing: -0.005em;
`;

const Secondary = styled.div`
  font-family: var(--font-sans);
  font-weight: 300;
  font-size: 13px;
  color: rgba(247, 245, 240, 0.7);
`;

const Meta = styled.div`
  font-family: var(--font-mono, monospace);
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: var(--color-gold-dim);
  white-space: nowrap;

  @media (max-width: 575px) {
    display: none;
  }
`;

const Arrow = styled.div`
  font-family: var(--font-serif);
  color: var(--color-gold-dim);
  font-size: 18px;
  transition: color 0.2s, transform 0.2s;

  ${Row}:hover & {
    color: var(--color-gold);
    transform: translateX(3px);
  }

  @media (max-width: 575px) {
    display: none;
  }
`;

export default ListItem;
